module.exports = __webpack_public_path__ + "img/img_1.6c7254bd.png";